
<button kendoButton type="button" (click)="save()" *ngIf="showExportButton" icon="excel">
  {{'global.excelExport.exportToExcelCaption' | translate}}
</button>

  <kendo-excelexport 
  [data]="data"
  [collapsible]="true"
  [fileName]="settings.fileName"
  #excelexport>


  <ng-container *ngFor="let column of settings.columns">
    <kendo-excelexport-column   [field]="column.field"   [title]="column.title | translate"  [width]="column.width" 
    [hidden]="column.hidden" [cellOptions]="column.cellOptions">

    </kendo-excelexport-column>
 </ng-container>



</kendo-excelexport>